import classNames from "classnames/bind";
import styles from "./index.module.scss";
import "swiper/swiper-bundle.min.css";

const cn = classNames.bind(styles);

function View({textSet, onClickHandler, btnText}) {
  return (
    <div className={cn("one_btn_popup")}>
      <div className={cn("one_btn_popup_text")}>
        {textSet.map(text => {
          return <span>{text}</span>;
        })}
      </div>
      <div className={cn("popup_button")}>
        <button className={cn("btn_close")} onClick={onClickHandler}>
          {btnText}
        </button>
      </div>
    </div>
  );
}

export default View;
